// extracted by mini-css-extract-plugin
module.exports = {"dotloader":"loader-dots_dotloader__1p5oY","bouncedelay":"loader-dots_bouncedelay__b8adr","dotloader1":"loader-dots_dotloader1__3seQq","dotloader2":"loader-dots_dotloader2__38r3z"};